import { useMemo, useState } from "react";
import { Flex, Input, Table } from "antd";
import { ActionButton, Modal, Button, Icon } from "ui";
import InfiniteSelect from "ui/infinite-select";
import { getRand } from "core/utils/common-utils";
import { useGetArticles } from "pages/articles/api";
import {
  useAddArticleToArticleLine,
  useDeleteFromArticleLine,
  useListArticleLineArticles,
} from "pages/mag-home-management/api";
import { useArticleLinesTabStore } from "../store";
import { CATEGORY_PRODCUTS_TABLE_COLUMN } from "pages/catalog/AddProductCategory/constant";

interface CategoryLineProductsModalProps {}
const ArticleLineArticlesModal: React.FC<
  CategoryLineProductsModalProps
> = () => {
  const [articlesPage, setArticlesPage] = useState(1);
  const [articlesKeyword, setArticlesKeyword] = useState("");
  const [selectedArticle, setSelectedArticle] = useState<number | undefined>(
    undefined
  );
  const [priority, setPriority] = useState<number | undefined>(undefined);
  const [refreshKey, setRefreshKey] = useState("");

  const { setArticlesModalData, articlesModalData } = useArticleLinesTabStore(
    (state) => state
  );

  const { mutate: addMutation, isPending: addingArticle } =
    useAddArticleToArticleLine();
  const { mutate: deleteMutation } = useDeleteFromArticleLine();

  const { data: articles, isPending: fetchingArticles } = useGetArticles({
    page: articlesPage,
    pageSize: 10,
    inputParams: {
      filters: [
        {
          propertyName: "title",
          operation: "contains",
          value: articlesKeyword,
        },
      ],
      sort: {
        propertyName: "id",
        ascending: false,
      },
    },
  });
  const articlesOptions = useMemo(
    () =>
      (articles?.data?.data ?? []).map((item: any) => ({
        label: item.title,
        value: item.id,
      })),
    [articles]
  );

  const {
    data: articleLineArticlesData,
    isPending: fetchingArticleLineArticlesData,
  } = useListArticleLineArticles({
    queryKey: [
      {
        articleLine: articlesModalData?.line,
      },
    ],
    enabled: (articlesModalData?.line ?? 0) > 0,
  });
  const articleLineArticles = articleLineArticlesData?.data?.data ?? [];

  const addArticleToArticleLine = () => {
    if (selectedArticle) {
      addMutation(
        {
          magHomePageArticleLineId: articlesModalData?.id,
          articleId: selectedArticle,
          priority,
        },
        {
          onSuccess: () => {
            setSelectedArticle(undefined);
            setPriority(undefined);
            setRefreshKey(`${getRand()}`);
          },
        }
      );
    }
  };

  const dataSource = useMemo(() => {
    return (
      articleLineArticles.map((item, index) => {
        return {
          key: item?.id,
          index: <label className="color-primary">{index + 1}</label>,
          product: <strong className="color-link">{item?.title ?? "-"}</strong>,
          action: (
            <ActionButton
              type="remove"
              onClick={() =>
                deleteMutation({
                  magHomePageArticleLineId: articlesModalData?.id ?? 0,
                  articleId: item.id,
                })
              }
            />
          ),
        };
      }) || []
    );
  }, [articleLineArticles]);

  return (
    <Modal
      name="MAG_HOME_PAGE_ARTICLE_LINE_ARTICLES_MODAL"
      title={`لیست مقالات لاین ${articlesModalData?.title ?? ""}`}
      width="60%"
      okButtonProps={{
        loading: false,
      }}
      onClose={() => {
        setArticlesModalData(undefined);
      }}
      footer={(cancel, ok) => (
        <>
          <Button
            loading={false}
            type="primary"
            onClick={() => {
              cancel();
            }}
          >
            بستن
          </Button>
        </>
      )}
    >
      <Flex align="center" gap={10} className="mb-2">
        <InfiniteSelect
          key={refreshKey}
          args={{ className: "w-100 px-3" }}
          placeholder="انتخاب مقاله جدید"
          value={selectedArticle}
          onChange={(e) => setSelectedArticle(e?.value)}
          options={articlesOptions}
          onInputChange={(phrase) => setArticlesKeyword(phrase)}
          isLoading={fetchingArticles}
          onPageChange={setArticlesPage}
          page={articlesPage}
        />
        <Input
          type="number"
          value={priority}
          onChange={(e) => setPriority(parseInt(e.target.value))}
          placeholder="اولویت نمایش را وارد کنید"
          className="w-50"
        />
        <Button
          type="primary"
          size="middle"
          onClick={() => {
            addArticleToArticleLine();
          }}
          className="py-5-2"
          loading={addingArticle}
        >
          <Icon type="sr-plus" />
          <span>افزودن</span>
        </Button>
      </Flex>
      <Table
        locale={{ emptyText: "مقاله ای به این لاین اضافه نشده است" }}
        columns={CATEGORY_PRODCUTS_TABLE_COLUMN}
        dataSource={dataSource}
        loading={fetchingArticleLineArticlesData}
        pagination={false}
      />
    </Modal>
  );
};
export default ArticleLineArticlesModal;
